import React from 'react';
import NoteBook from '../../../../../assets/note-book.png';
import Button from 'components/Form/Button';
import { InfoModal } from 'components/Modal';
import { useGeneratePDF } from 'common/queries-and-mutations/user';
import { Icon, Icons } from 'components/Icon';
import { Loader } from 'components/Loader';

type IProps = {
  name: string;
  onSend: () => void;
  onCancel: () => void;
  isSubmitting: boolean;
};

export default function WillPreview({
  name,
  onSend,
  onCancel,
  isSubmitting
}: IProps) {
  const { data, isLoading } = useGeneratePDF();

  return (
    <InfoModal width="w-[60%]" className="h-fit rounded-md p-5">
      <div className="border-b-2 border-[#EBEBEB]">
        <div className="bottom-1 flex items-center justify-between">
          <div className="flex items-center">
            <p className="text-2xl font-bold text-[#353535]">{name}</p>
            <img src={NoteBook} />
          </div>
          <button type="button" onClick={onCancel}>
            <Icon name={Icons.Close} />
          </button>
        </div>
      </div>
      {isLoading ? (
        <div className="my-20 flex flex-col items-center justify-center">
          <Loader type="Wait" color={'#FF6606'} height={50} width={50} />
        </div>
      ) : (
        <>
          <div className="mt-5 flex flex-col items-center justify-center   pb-10 text-center">
            <iframe
              className="h-[500px] w-[800px] rounded bg-[#F4F4F4]"
              src={`data:application/pdf;base64,${data}`}
            />
          </div>
          <div className="my-2 flex justify-end px-[2rem]">
            <Button
              variant="primary"
              size="md"
              className="w-[9rem] rounded border-none px-[0.5rem] text-sm font-bold"
              label="Send To Lawyer"
              type="button"
              onClick={() => onSend()}
              loading={isSubmitting}
              disabled={isSubmitting}
            ></Button>
          </div>
        </>
      )}
    </InfoModal>
  );
}
